<template>
    <form
      class="form-search"
      :class="isSearchPage && 'form-search--page'"
      :disabled="disabled"
      @submit.prevent="() => !dynamic && onSubmit()"
    >
        <label class="form-search__inner" :class="{ 'borderless': borderless }">
          <input
            class="form-search__input"
            type="text"
            v-model="inputValue"
            :placeholder="placeholder"
            :disabled="disabled"
            ref="input"
            @input="() => dynamic && onSubmit()"
          />

          <button class="form-search__button form-search__button--submit" :disabled="disabled">
              <svg class="search-icon" viewBox="0 0 23 23" fill="none"
                  xmlns="http://www.w3.org/2000/svg">
                  <circle cx="10.0328" cy="10.0294" r="8.2945" stroke-width="1.5" />
                  <path d="M15.8472 15.8438L21.6615 21.6581" stroke-width="1.5" />
              </svg>
          </button>

          <button
            v-if="inputValue"
            class="form-search__button form-search__button--reset "
            :disabled="disabled"
            type="button"
            @click="clearValue"
          >
            x
          </button>

          <button v-if="!dynamic" v-show="false" />
        </label>
    </form>
</template>

<script>

export default {
  name: 'SearchForm',
  model: {
    prop: 'value',
    event: 'valueChange'
  },
  props: {
    value: String,
    placeholder: {
      type: String,
      default: 'Поиск'
    },
    borderless: {
      type: Boolean,
      default: false
    },
    disabled: Boolean,
    dynamic: {
      type: Boolean,
      default: false
    },
    isSearchPage: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    inputValue: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('valueChange', val)
      }
    }
  },
  methods: {
    onSubmit () {
      const value = this.$refs.input.value || this.inputValue
      this.$emit('form-submit', value)
    },
    clearValue () {
      this.inputValue = ''
      this.$emit('form-submit', '')
    }
  }
}

</script>

<style lang="scss" scoped>
@import '../../../assets/css/system/_vars';
@import '../../../assets/css/system/_mixins';

.form-search {
  width: 100%;
  height: 40px;

  &--page {
    width: 500px;

    @media screen and (max-width:1560px) {
      width: 400px !important;
    }

    @media screen and (max-width:1300px) {
      width: 360px !important;
    }

    @media screen and (max-width:1260px) {
      width: 300px !important;
    }

    @media screen and (max-width:1180px) {
      width: 260px !important;
    }
  }

  &__inner {
    position: relative;
    display: flex;
    width: 100%;
    background: $color_main;
    border: 1px solid $color_third-dark;
    border-radius: 3px;
    transition: .3s;

    &.borderless {
      border: none !important;
    }

    @media screen and (min-width: $hover_enable_width) {
      &:hover {
        border: 1px solid $color_second-light;
      }
    }
  }

  &__input {
    flex: 1;
    width: 100%;
    height: 100%;
    padding: 10px 40px 10px 15px;
    color: $font_color_second;
    background: transparent;
    transition: .3s;

    &:focus {
      box-shadow: inset 0 4px 4px rgba(23, 63, 125, 0.25);
    }
  }

  &__button {
    position: absolute;
    top: 0;
    right: 5px;
    height: 100%;
    cursor: pointer;
    background: transparent;
    color: $color_second-light;

    &--reset {
      right: 40px;
    }
  }

  &[disabled] {
    pointer-events: none;

    .form-search {
      &__inner {
        border: 1px solid $color_deactive !important;
      }

      &__submit {
        color: $color_deactive !important;
      }
    }
  }
}
</style>
